import { WithdrawalSubmitted } from '../../../../investment/components/transfer/WithdrawalSubmitted';

export default function WithdrawalSubmittedScreen() {
    return <WithdrawalSubmitted />;
}
